import { TabsList, TabsTrigger } from "../ui";

const CustomTabList = ({ tabs }: { tabs: any }) => {
  return (
    <TabsList className="gap-x-4 bg-transparent mb-30 lg:mb-4 grid grid-cols-3 lg:flex">
      {tabs.map((tab: { title: string; value: string }) => (
        <TabsTrigger
          value={tab.value}
          key={`tab-${tab.value}`}
          className="w-20 py-3 lg:py-5 text-[16px] -leading-[0.5%] text-g-700     px-0 border-0 shadow-none data-[state=active]:shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-b-primary data-[state=active]:text-primary data-[state=active]:font-bold cursor-pointer"
        >
          {tab.title}
        </TabsTrigger>
      ))}
    </TabsList>
  );
};

export default CustomTabList;
